import axios from 'axios';

axios.defaults.timeout = 5 * 60 * 1000;

export function setBaseUrl() {
    axios.defaults.baseURL = window.WEB_CAB_URL || '/';
}
